import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Website} from "../../../website";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../store';
import {CloudflareService} from "../../services/cloudflare.service";
import {UserSubscription, UserSubscriptionCategory} from '../../../../../user/user-subscription';
import {User} from '../../../../../user/user';
import features from './cdn-features.json';
import {DbModalService} from "../../../../../modules/modal/modal";
import {
  EnableCloudflareDialogComponent
} from "../dialogs/enable-cloudflare-integration/enable-cloudflare-dialog.component";
import {Subject} from "rxjs";
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {Utils} from "../../../../../shared/utils/utils";
import {Config} from "../../../../../config/config";
import {HostingDomainData} from "../../../hosting/domains/hostingDomainData";
import {DialogService} from "../../../../../../ng2-bootstrap-modal/dialog.service";
import {
  PaidFeatureUpgradeComponent
} from "../../../../../shared/components/dialogs/paid-feature-upgrade/paid-feature-upgrade.component";
import {PaymentDialogComponent} from "../../../../../workspace/billing/payment-dialog/payment-dialog.component";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {
  NotificationDialogComponent
} from "../../../../../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {TextUtils} from "../../../../../shared/utils/text-utils";
import {filter, first, takeUntil} from "rxjs/operators";
import {TypeUtils} from "../../../../../shared/utils/type-utils";
import {Workspace} from "../../../../../user-managment/workspace";
import {clientRoles} from "../../../../../user/user-roles-actions";
import {CookieService} from "ngx-cookie";
import {
  OneWeekFreeDemoUpgradeComponent
} from "../../../../../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/one-week-free-demo-upgrade.component";
import {
  PricingPageViewComponent
} from "../../../../../shared/components/dialogs/one-month-free/components/pricing-page-view/pricing-page-view.component";

interface IFeature {
  img?: any;
  title: string;
  desc: string;
}

@Component({
    selector: 'db-cdn-disabled',
    templateUrl: './cdn-disabled.component.html',
    styleUrls: ['./cdn-disabled.component.scss'],
    standalone: false
})
export class CdnDisabledComponent implements OnInit, OnChanges {
  protected readonly clientRoles = clientRoles;
  @Input() currentSubscription: UserSubscription;
  @Input() user: User;
  @Input() isNameServer: boolean;
  @Input() hasCertificate: boolean;
  @Input() serverIp: any;
  @Input() enabledCdnCount: number;
  @Input() currentWorkspace: Workspace;
  @Input() website: Website;
  public defaultRecord: any = null;

  public UserSubscriptionCategory: any = UserSubscriptionCategory;
  public loadingApply: boolean;
  public features: IFeature[];
  public hasSslCertificate: boolean = true;
  public siteUrl: string;
  public primaryChanged: boolean;
  public domains: HostingDomainData[];
  public canEnable: boolean;
  public showPercentOffer: boolean;
  public options: any;
  public showDesc: number;
  public pageLoadTime: number;
  public pageScore: number;
  public dataLoading: boolean = true;
  public demoUser: boolean;
  public isMember = false;

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _dbModalService: DbModalService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _cloudflareService: CloudflareService,
    private _store: Store<fromStore.DbStoreState>,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _dialogService: DialogService,
    private _modalService: DbModalService,
    private _cookieService: CookieService,
  ) {
  }

  static _isValidHttpsUrl(string): boolean {
    try {
      const url = new URL(string);
      return url.protocol === 'https:';
    } catch (err) {
      return false;
    }
  }

  ngOnInit() {
    this.isMember = [clientRoles.SITE_DEV, clientRoles.COMPANY_DEV].includes(this.currentWorkspace?.roleId);
    this.demoUser = Utils.isDemoUser(this.currentSubscription, this.user);
    this.options = [
      {
        img: "assets/images/icons/speed-green.svg",
        text: TextUtils.getText('text_proOptimCdnOptionLong1'),
      },
      {
        img: "assets/images/icons/speed-time.svg",
        text: TextUtils.getText('text_proOptimCdnOptionLong2'),
      },
      {
        img: "assets/images/icons/speed-globe.svg",
        text: TextUtils.getText('text_proOptimCdnOptionLong3'),
      }
    ];
    this.currentSubscription && this.currentSubscription.trialBoosterClient ? this.features = features.boosterFree : this.features = features.paid;
    this.website = this._route.snapshot.parent.parent.data['website'];
    this.primaryChanged = !Utils.checkStringInArray(this.website.site_url, Config.hostnameList);
    this.currentSubscription && this.currentSubscription.trialBoosterClient && this.toggleArrow(0);
    this.hasSslCertificate = this.website && this.website.connectedFrom === 'speed_optimizer' ? CdnDisabledComponent._isValidHttpsUrl(this.website.site_url) : this.primaryChanged && this.hasCertificate;
    // this.currentSubscription.boosterProClient && this._checkSslCertificate();
    this._getCFDefaultDnsRecord();
    this._showPercentOffer();
    this._openEnableDialog();
    this.website && this._store.select(fromStore.getWebsite(this.website?.id))
      .pipe(
        takeUntil(this._destroyStream$),
        filter(website => !!website)
      )
      .subscribe((website: Website) => {
        this.website = website;
        this.pageLoadTime = this.website ? this.website.score && this.website.score.currentScore && (this.website.score.currentScore.desktopTTI >
        this.website.score.currentScore.mobileTTI ? this.website.score.currentScore.desktopTTI : this.website.score.currentScore.mobileTTI) : null;
        this.pageScore = this.website ? this.website.score && this.website.score.currentScore && (this.website.score.currentScore.desktopScore >
        this.website.score.currentScore.mobileScore ? this.website.score.currentScore.mobileScore : this.website.score.currentScore.desktopScore) : null;
        this.dataLoading = false;
        this.siteUrl = this.website && this.website.site_url.replace(/(^\w+:|^)\/\//, '') || '';
        this.primaryChanged = !Utils.checkStringInArray(this.website.site_url, Config.hostnameList);
        this.hasSslCertificate = this.website && this.website.connectedFrom === 'speed_optimizer' ? CdnDisabledComponent._isValidHttpsUrl(this.website.site_url) : this.primaryChanged && this.hasCertificate;
        if (this.currentSubscription) {
          if (!this.currentSubscription.boosterProClient && this.currentSubscription.plan && this.currentSubscription.plan.additionalCDNCount) {
            this.canEnable = this.enabledCdnCount < (this.currentSubscription.plan.additionalCDNCount + +(this.currentSubscription.plan.cdnCountValue || 0))
              && this.website && !this.website.cloudflareEnabled;
          } else {
            this.canEnable = this.currentSubscription && this.currentSubscription.canEnableCdn && this.website && !this.website.cloudflareEnabled;
          }
        }
      });

  }

  private _openEnableDialog(): void {
    const queryParams: any = (<any>this._route.queryParams).value;
    if (Utils.isTruthy(queryParams.show_enable_dialog) && this.hasSslCertificate) {
      this.enable(true);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['enabledCdnCount']) {
      if (changes['enabledCdnCount'].currentValue) {
        this.enabledCdnCount = changes['enabledCdnCount'].currentValue;
      }
    }
    if (changes['hasCertificate']) {
      if (changes['hasCertificate'].currentValue) {
        this.hasCertificate = changes['hasCertificate'].currentValue;
        this.hasSslCertificate = this.website && this.website.connectedFrom === 'speed_optimizer' ? CdnDisabledComponent._isValidHttpsUrl(this.website.site_url) : this.primaryChanged && this.hasCertificate;
      }
    }
  }

  private _getCFDefaultDnsRecord(): void {
    this._store.select(fromStore.getCloudflareDefaultRecord(this.website?.id))
      .pipe(
        takeUntil(this._destroyStream$))
      .subscribe(data => {
        if (!TypeUtils.isNull(data) && !TypeUtils.isEmpty(data)) {
          this.defaultRecord = data;
        }
      });
  }

  private _showPercentOffer() {
    const percentOfferEndDate = new Date("2024-01-30 18:00:00").getTime();
    const datesDiff = Utils.getTimeDiffFromToday(percentOfferEndDate);
    this.showPercentOffer = datesDiff && this.currentSubscription && this.currentSubscription.trialBoosterClient;
  }


  public upgrade(): void {
    this._router.navigate([`/upgrade-plan`]);
  }

  public redirect(location): void {
    this._router.navigate([`/websites/${this.website?.id}/${location}`]);
  }

  public enable(openDialogFromUrl: boolean = false): void {
    /*TODO check can be with tenweb_ns*/
    if (!this.isNameServer) {
      const modal = this._dbModalService.open(EnableCloudflareDialogComponent);
      modal.componentInstance.websiteId = this.website?.id;
      modal.componentInstance.websiteUrl = this.website?.site_url;
    } else if (!!this.isNameServer) {
      this._enableForPaidPlatform();
    }
  }

  public buyNow(): void {
    if (this.currentSubscription && this.currentSubscription.status === 'canceled') {
      this._router.navigate(['/workspace/subscription-plan']);
    } else if (this.user && this.user.oneProductOrBundleClient) {
      this._router.navigate(['/upgrade-plan']);
    } else {
      if (this.currentSubscription && this.currentSubscription.trialClient) {
        if (this.demoUser) {
          const options = {
            overflowHidden: false,
            isPaidFeature: true,
            backdropClass: 'blurred',
          };
          options['width'] = this.website?.isEcommerceWebsite ? 960 : 1240;
          options['height'] = this.website?.isEcommerceWebsite ? 1024 : 878;
          const modal = this._modalService.open(OneWeekFreeDemoUpgradeComponent, options);
          modal.componentInstance.mode = 'cloudflare';
          modal.componentInstance.modeDesc = 'For security reasons Cloudflare Enterprise add-on is only' +
            ' available to paid users.</br>  To access Cloudflare Enterprise please make a payment.';
          modal.closed.subscribe(() => this._store.dispatch(new fromStore.LoadInfo(this.website.id)));
        } else {
          const modal = this._modalService.open(PricingPageViewComponent, { overflowHidden: true, height: 960, width: 1076});
          modal.componentInstance.user = this.user;
          modal.closed.subscribe(() => this._store.dispatch(new fromStore.LoadInfo(this.website?.id)));
        }
      } else {
        this._dialogService.addDialog(PaymentDialogComponent, {
          upgradeSubscription: this.currentSubscription,
          fromDialog: true,
          renew: false,
          showAdditional: true,
          extend: false,
          buyCdnAddOn: true
        });
      }
    }
  }

  public toggleArrow(index): void {
    this.showDesc === index ? this.showDesc = -1 : this.showDesc = index;
  }

  private _enableForPaidPlatform(): void {
    this.loadingApply = true;
    this._cloudflareService.enableCloudflare(this.website?.id, this.serverIp)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this.loadingApply = false;
          this._showIntegrationDialog();
          this._store.dispatch(new fromStore.LoadWebsites());
          this._store.dispatch(new fromStore.LoadCloudflareData(this.website?.id));
        } else {
          NotifierComponent.notify(new Notification('Something Went Wrong...', NotificationType.DANGER));
        }
      });
  }

  private _showIntegrationDialog(): void {
    this._dialogService.addDialog(NotificationDialogComponent, {
      header: TextUtils.getText('text_cdnIntegrationInProgress'),
      message: TextUtils.getText('text_cdnIntegrationMessage'),
      buttonText: 'Got It',
      buttonColor: 'green',
      hasCloseButton: false
    });
  }
}
